import { useEffect, useState } from 'react'

import { PluginClient } from '@remixproject/plugin'
import { IRemixApi } from '@remixproject/plugin-api'
import { PluginApi } from '@remixproject/plugin-utils'

import Dropdown from 'react-bootstrap/Dropdown'

import { SUPPORTED_COMPILER_VERSIONS } from '../../utils/constants'

type CompilerVersionProps = {
    client: PluginClient<any, Readonly<IRemixApi>> & PluginApi<Readonly<IRemixApi>>
}

const CompilerVersion = ({ client }: CompilerVersionProps) => {
    const [compilerVersion, setCompilerVersion] = useState('')

    const formatCompilerVersion = (version: string) => {
        return version.split("+")[0]
    }

    const updateCompilerVersion = async (version: string) => {
        await client.solidity.setCompilerConfig({
            language: 'Solidity',
            optimize: false,
            version: version
        })
        
        setCompilerVersion(formatCompilerVersion(version))
    }

    useEffect(() => {
        client.onload(async () => {
            updateCompilerVersion(SUPPORTED_COMPILER_VERSIONS[0])
        })
    }, [])

    return (
        <>
            <p className='compiler-version'><b>Compiler Version</b></p>

            <Dropdown className='compiler-version-dropdown'>
                <Dropdown.Toggle variant="secondary" size='sm'>{compilerVersion}</Dropdown.Toggle>
                    <Dropdown.Menu>
                        {SUPPORTED_COMPILER_VERSIONS.map((version, index) => {
                            return <Dropdown.Item as="button" key={index} onClick={async () => updateCompilerVersion(version)}>{formatCompilerVersion(version)}</Dropdown.Item>
                        })}
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
}

export default CompilerVersion